import React from 'react';
import { FadeIn } from './FadeIn';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Llevaba meses pensando que mi hijo tenía un problema de conducta. Le grité, le castigué, le quité la tablet por semanas. Nada funcionaba. Cuando apliqué el Puente de Interés por primera vez, me quedé sin palabras. Mi hijo SOLITO apagó el juego cuando le pregunté sobre lo que estaba jugando. Llevó 4 minutos. Cuatro. Minutos. Lloré de alivio.',
    author: 'Mariana G.',
    role: 'mamá de Santiago, 7 años',
    location: 'Monterrey, México'
  }, {
    quote: 'Soy papá soltero de dos niñas de 5 y 9 años. Las tardes eran un infierno. Una quería seguir viendo YouTube y la otra lloraba porque yo gritaba. Este manual me dio un lenguaje nuevo para hablar con ellas. La respiración del globo se convirtió en un juego que las dos piden hacer. Mi casa cambió en literalmente 3 días. Tres días.',
    author: 'Roberto A.',
    role: 'papá de Camila y Sofía',
    location: 'Bogotá, Colombia'
  }, {
    quote: 'Lo que más me impactó fue entender que cuando mi hijo grita al apagar la pantalla, no es capricho — es química cerebral. Eso solo, entender eso, me cambió como mamá. Ya no reacciono con miedo o enojo. Ahora respiro yo primero. Y él me sigue. El manual es claro, corto, práctico y se siente como hablar con alguien que de verdad entiende lo que vivimos.',
    author: 'Daniela R.',
    role: 'mamá de Mateo, 6 años',
    location: 'Buenos Aires, Argentina'
  }];
  return <section className="w-full py-24 px-6 bg-cream" data-id="element-336">
      <div className="max-w-6xl mx-auto" data-id="element-337">
        <FadeIn data-id="element-338">
          <div className="text-center mb-16" data-id="element-339">
            <div className="flex justify-center gap-1 mb-4" data-id="element-340">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-8 h-8 fill-amber text-amber" data-id="element-341" />)}
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-charcoal font-serif" data-id="element-342">
              Familias Reales. Cambios Reales.
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-343">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-344">
              <div className="bg-white p-8 rounded-3xl shadow-sm border border-cream-dark relative h-full flex flex-col" data-id="element-345">
                <Quote className="absolute top-6 right-6 w-12 h-12 text-cream-dark opacity-50" data-id="element-346" />

                <div className="flex gap-1 mb-6" data-id="element-347">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber text-amber" data-id="element-348" />)}
                </div>

                <p className="text-charcoal-light italic mb-8 flex-grow leading-relaxed" data-id="element-349">
                  "{testimonial.quote}"
                </p>

                <div className="mt-auto pt-6 border-t border-cream" data-id="element-350">
                  <p className="font-bold text-charcoal text-lg" data-id="element-351">
                    {testimonial.author}
                  </p>
                  <p className="text-terracotta text-sm mb-1" data-id="element-352">
                    {testimonial.role}
                  </p>
                  <p className="text-gray-400 text-sm flex items-center gap-1" data-id="element-353">
                    📍 {testimonial.location}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}